// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"da9614fb469010498214","6980":"167fa4b51f76c6e61712"}[chunkId] + ".js";
};